<template>
    <section>
        <div :class="{
            'faqs-container': isFaqsPage,
        }">
            <Accordion :headline="props.headline" :bgColor="props.bgColor" :cta="props.cta" :accordion-details="faqsAccordionDetails"></Accordion>
        </div>
    </section>
</template>
<script lang="ts" setup>
import type { Cta } from "@interfaces/Cta.ts";
import type { PropType } from "vue";
import { ref,computed } from "vue";
import Accordion from "@/components/Accordion.vue";
import { route } from 'ziggy-js'
interface Faq {
    question: string;
    answer: string;
}

let props = defineProps({
    headline: {
        type: String,
        required: true,
        default: "",
    },
    faqs: {
        type: Array<Faq>,
        required: true,
        default: [],
    },
    bgColor: {
        type: String,
        required: false,
        default: 'rothcoCream'
    },
    cta: {
        type: Object as PropType<Cta>,
        required: false,
        default(){
            return {};
        },
    },
});

let faqsAccordionDetails = computed(()=>{
    return props.faqs.map(faq=>{
        return {title: faq.question, content: faq.answer}
    });
});

let isFaqsPage = computed(()=>{
    return route().current() == 'customer-service.faqs'
})
</script>